export const countryOptions = [
    { value: 'USD', label: 'United States Dollar (USD)' },
    { value: 'EUR', label: 'Euro (EUR)' },
    { value: 'JPY', label: 'Japanese Yen (JPY)' },
    { value: 'GBP', label: 'British Pound (GBP)' },
    { value: 'AUD', label: 'Australian Dollar (AUD)' },
    { value: 'CAD', label: 'Canadian Dollar (CAD)' },
    { value: 'CHF', label: 'Swiss Franc (CHF)' },
    { value: 'CNY', label: 'Chinese Yuan (CNY)' },
    { value: 'SEK', label: 'Swedish Krona (SEK)' },
    { value: 'NZD', label: 'New Zealand Dollar (NZD)' },
    { value: 'INR', label: 'Indian Rupee (INR)' },
    { value: 'BRL', label: 'Brazilian Real (BRL)' },
    { value: 'ZAR', label: 'South African Rand (ZAR)' },
    { value: 'RUB', label: 'Russian Ruble (RUB)' },
    { value: 'SGD', label: 'Singapore Dollar (SGD)' },
    { value: 'HKD', label: 'Hong Kong Dollar (HKD)' },
    { value: 'KRW', label: 'South Korean Won (KRW)' },
    { value: 'MXN', label: 'Mexican Peso (MXN)' },
    { value: 'IDR', label: 'Indonesian Rupiah (IDR)' },
    { value: 'TRY', label: 'Turkish Lira (TRY)' },
    { value: 'SAR', label: 'Saudi Riyal (SAR)' },
    { value: 'AED', label: 'United Arab Emirates Dirham (AED)' },
    { value: 'NOK', label: 'Norwegian Krone (NOK)' },
    { value: 'DKK', label: 'Danish Krone (DKK)' },
    { value: 'PLN', label: 'Polish Zloty (PLN)' },
    { value: 'THB', label: 'Thai Baht (THB)' },
    { value: 'MYR', label: 'Malaysian Ringgit (MYR)' },
    { value: 'PHP', label: 'Philippine Peso (PHP)' },
    { value: 'CZK', label: 'Czech Koruna (CZK)' },
    { value: 'HUF', label: 'Hungarian Forint (HUF)' },
    { value: 'ILS', label: 'Israeli Shekel (ILS)' },
    { value: 'CLP', label: 'Chilean Peso (CLP)' },
    { value: 'PKR', label: 'Pakistani Rupee (PKR)' },
    { value: 'EGP', label: 'Egyptian Pound (EGP)' },
    { value: 'NGN', label: 'Nigerian Naira (NGN)' },
    { value: 'BDT', label: 'Bangladeshi Taka (BDT)' },
    { value: 'VND', label: 'Vietnamese Dong (VND)' },
    { value: 'COP', label: 'Colombian Peso (COP)' },
    { value: 'ARS', label: 'Argentine Peso (ARS)' },
    { value: 'PEN', label: 'Peruvian Sol (PEN)' },
    { value: 'KWD', label: 'Kuwaiti Dinar (KWD)' },
    { value: 'QAR', label: 'Qatari Riyal (QAR)' },
    { value: 'OMR', label: 'Omani Rial (OMR)' },
    { value: 'BHD', label: 'Bahraini Dinar (BHD)' },
    { value: 'JOD', label: 'Jordanian Dinar (JOD)' },
    { value: 'LKR', label: 'Sri Lankan Rupee (LKR)' },
    { value: 'MMK', label: 'Myanmar Kyat (MMK)' },
    { value: 'KES', label: 'Kenyan Shilling (KES)' },
    { value: 'TZS', label: 'Tanzanian Shilling (TZS)' },
    { value: 'UGX', label: 'Ugandan Shilling (UGX)' },
    { value: 'GHS', label: 'Ghanaian Cedi (GHS)' },
    { value: 'XOF', label: 'West African CFA Franc (XOF)' },
    { value: 'XAF', label: 'Central African CFA Franc (XAF)' },
    { value: 'MAD', label: 'Moroccan Dirham (MAD)' },
    { value: 'DZD', label: 'Algerian Dinar (DZD)' },
    { value: 'TND', label: 'Tunisian Dinar (TND)' },
    { value: 'LBP', label: 'Lebanese Pound (LBP)' },
    { value: 'JMD', label: 'Jamaican Dollar (JMD)' },
    { value: 'TTD', label: 'Trinidad and Tobago Dollar (TTD)' },
    { value: 'BBD', label: 'Barbadian Dollar (BBD)' },
    { value: 'BZD', label: 'Belize Dollar (BZD)' },
    { value: 'BMD', label: 'Bermudian Dollar (BMD)' },
    { value: 'BSD', label: 'Bahamian Dollar (BSD)' },
    { value: 'KYD', label: 'Cayman Islands Dollar (KYD)' },
    { value: 'FJD', label: 'Fijian Dollar (FJD)' },
    { value: 'SBD', label: 'Solomon Islands Dollar (SBD)' },
    { value: 'PGK', label: 'Papua New Guinean Kina (PGK)' },
    { value: 'WST', label: 'Samoan Tala (WST)' },
    { value: 'TOP', label: 'Tongan Paʻanga (TOP)' },
    { value: 'VUV', label: 'Vanuatu Vatu (VUV)' },
    { value: 'MOP', label: 'Macanese Pataca (MOP)' },
    { value: 'TWD', label: 'New Taiwan Dollar (TWD)' },
    { value: 'MNT', label: 'Mongolian Tugrik (MNT)' },
    { value: 'KZT', label: 'Kazakhstani Tenge (KZT)' },
    { value: 'UZS', label: 'Uzbekistani Som (UZS)' },
    { value: 'TMT', label: 'Turkmenistani Manat (TMT)' },
    { value: 'KGS', label: 'Kyrgyzstani Som (KGS)' },
    { value: 'AFN', label: 'Afghan Afghani (AFN)' },
    { value: 'IRR', label: 'Iranian Rial (IRR)' },
    { value: 'IQD', label: 'Iraqi Dinar (IQD)' },
    { value: 'SYP', label: 'Syrian Pound (SYP)' },
    { value: 'YER', label: 'Yemeni Rial (YER)' },
    { value: 'MVR', label: 'Maldivian Rufiyaa (MVR)' },
    { value: 'NPR', label: 'Nepalese Rupee (NPR)' },
    { value: 'BTN', label: 'Bhutanese Ngultrum (BTN)' },
    { value: 'MGA', label: 'Malagasy Ariary (MGA)' },
    { value: 'SCR', label: 'Seychellois Rupee (SCR)' },
    { value: 'ZMW', label: 'Zambian Kwacha (ZMW)' },
    { value: 'MWK', label: 'Malawian Kwacha (MWK)' },
    { value: 'BWP', label: 'Botswana Pula (BWP)' },
    { value: 'NAD', label: 'Namibian Dollar (NAD)' },
    { value: 'SZL', label: 'Swazi Lilangeni (SZL)' },
    { value: 'LSL', label: 'Lesotho Loti (LSL)' },
    { value: 'MZN', label: 'Mozambican Metical (MZN)' },
    { value: 'AOA', label: 'Angolan Kwanza (AOA)' },
    { value: 'GNF', label: 'Guinean Franc (GNF)' },
    { value: 'SLL', label: 'Sierra Leonean Leone (SLL)' },
    { value: 'LRD', label: 'Liberian Dollar (LRD)' },
    { value: 'GMD', label: 'Gambian Dalasi (GMD)' },
    { value: 'XCD', label: 'East Caribbean Dollar (XCD)' },
    { value: 'HTG', label: 'Haitian Gourde (HTG)' },
    { value: 'DOP', label: 'Dominican Peso (DOP)' },
    { value: 'CUP', label: 'Cuban Peso (CUP)' },
    { value: 'CUC', label: 'Cuban Convertible Peso (CUC)' },
    { value: 'JEP', label: 'Jersey Pound (JEP)' },
    { value: 'GGP', label: 'Guernsey Pound (GGP)' },
    { value: 'IMP', label: 'Isle of Man Pound (IMP)' },
    { value: 'FKP', label: 'Falkland Islands Pound (FKP)' },
    { value: 'SHP', label: 'Saint Helena Pound (SHP)' },
    { value: 'ANG', label: 'Netherlands Antillean Guilder (ANG)' },
    { value: 'AWG', label: 'Aruban Florin (AWG)' },
    { value: 'BIF', label: 'Burundian Franc (BIF)' },
    { value: 'DJF', label: 'Djiboutian Franc (DJF)' },
    { value: 'ETB', label: 'Ethiopian Birr (ETB)' },
    { value: 'KMF', label: 'Comorian Franc (KMF)' },
    { value: 'CDF', label: 'Congolese Franc (CDF)' },
    { value: 'RWF', label: 'Rwandan Franc (RWF)' },
    { value: 'STD', label: 'São Tomé and Príncipe Dobra (STD)' },
    { value: 'ERN', label: 'Eritrean Nakfa (ERN)' },
    { value: 'BAM', label: 'Bosnia and Herzegovina Convertible Mark (BAM)' },
    { value: 'MKD', label: 'Macedonian Denar (MKD)' },
    { value: 'ALL', label: 'Albanian Lek (ALL)' },
    { value: 'GEL', label: 'Georgian Lari (GEL)' },
    { value: 'AMD', label: 'Armenian Dram (AMD)' },
    { value: 'AZN', label: 'Azerbaijani Manat (AZN)' },
    { value: 'BYN', label: 'Belarusian Ruble (BYN)' },
    { value: 'MDL', label: 'Moldovan Leu (MDL)' },
    { value: 'UAH', label: 'Ukrainian Hryvnia (UAH)' },
    { value: 'GIP', label: 'Gibraltar Pound (GIP)' },
    { value: 'BND', label: 'Brunei Dollar (BND)' },
    { value: 'KHR', label: 'Cambodian Riel (KHR)' },
    { value: 'LAK', label: 'Lao Kip (LAK)' },
    { value: 'MMK', label: 'Myanmar Kyat (MMK)' },
    { value: 'KPW', label: 'North Korean Won (KPW)' },
    { value: 'AED', label: 'Dubai (AED)' },
    { value: 'MOP', label: 'Macanese Pataca (MOP)' }
];
